import { render, staticRenderFns } from "./SignupMessage.vue?vue&type=template&id=017c6844&scoped=true"
import script from "./SignupMessage.vue?vue&type=script&lang=ts"
export * from "./SignupMessage.vue?vue&type=script&lang=ts"
import style0 from "./SignupMessage.vue?vue&type=style&index=0&id=017c6844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017c6844",
  null
  
)

export default component.exports